import { createFileRoute } from "@tanstack/react-router";
import { FeaturesPage } from "@/features/marketing/features-page";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/$lang/features")({
  head: SEO.features,
  component: FeaturesPage,
});
